import { ESTADOS_PALETIZACION } from "../../../../../../../../../utility/constants";

export const GetEstadoBadge = (estado) => {
    switch (estado) {
        case ESTADOS_PALETIZACION.SIN_ENVIAR:
            return {
                text: "Sin enviar",
                variant: "warning",
            };
        case ESTADOS_PALETIZACION.PENDIENTE:
            return {
                text: "Pendiente",
                variant: "default",
            };
        case ESTADOS_PALETIZACION.ACEPTADO_PARCIAL:
            return {
                text: "Aceptado parcial",
                variant: "warning",
            };
        case ESTADOS_PALETIZACION.RECHAZADO:
            return {
                text: "Rechazado",
                variant: "danger",
            };
        case ESTADOS_PALETIZACION.ACEPTADO:
            return {
                text: "Aceptado",
                variant: "success",
            };
        default:
            return {
                text: estado || "Desconocido",
                variant: "secondary",
            };
    }
};
